export default {
  iconHolder: {
    flexShrink: '0',
    margin: '0 10px 0 0',
    width: '15px',
    height: '15px',
    '& > *': {
      width: '100%',
      height: '100%',
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }
}
